import { Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { IconButton, type IconButtonColor, type IconButtonVariant } from '@sm-dashboard/ui-components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React from 'react';

export type MenuAction = {
  label: string;
  onClick: () => void;
  icon: React.ReactNode;
};

export const LongMenu = ({
  actions,
  buttonStyle,
  buttonVariant = 'contained',
  buttonColor = 'primary',
  buttonSize = 'small'
}: {
  actions: MenuAction[];
  buttonStyle?: React.CSSProperties;
  buttonVariant?: IconButtonVariant;
  buttonColor?: IconButtonColor;
  buttonSize?: 'small' | 'medium' | 'large';
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Box sx={{ display: 'inline-flex', mr: 1, ...buttonStyle }}>
        <IconButton
          aria-label="פעולות נוספות"
          id="long-button"
          aria-controls={open ? 'long-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          color={buttonColor}
          variant={buttonVariant}
          shape="circle"
          size={buttonSize}
          onClick={handleClick}
        >
          <MoreVertIcon fontSize="inherit" />
        </IconButton>
      </Box>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
          disablePadding: true,
          sx: { p: 1 }
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: { minWidth: 180 }
        }}
      >
        {actions.flatMap((action, index) => [
          index > 0 && <Divider key={`divider-${index}`} sx={{ '&&': { my: 0.5 } }} />,
          <MenuItem
            key={index}
            sx={{ py: 1.25, px: 1.5, borderRadius: '8px' }}
            onClick={() => {
              action.onClick();
              handleClose();
            }}
          >
            <ListItemIcon>{action.icon}</ListItemIcon>
            <ListItemText>{action.label}</ListItemText>
          </MenuItem>
        ])}
      </Menu>
    </div>
  );
};
